var _circle, _path, _path2, _path3, _rect, _path4, _path5, _path6, _path7, _path8, _ellipse, _circle2, _circle3, _circle4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSportsGolfCartContrast = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 42.5,
    r: 42.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.9067 16.0216L60.2991 41.4363L62.4892 40.8487L53.6061 16.0216H50.9067Z",
    fill: "#1E1E1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.591 37.3392L62.7588 47.6948C63.0494 47.9643 63.1273 48.3932 62.9501 48.7477L62.6772 49.2934C62.4109 49.8259 61.7076 49.953 61.2718 49.5473L49.8169 38.8824C49.6891 38.7634 49.5292 38.6845 49.357 38.6556L47.1277 38.2809C46.8433 38.233 46.5532 38.3258 46.3492 38.5297L45.3847 39.4943C45.0275 39.8514 44.4454 39.841 44.1013 39.4714L43.9301 39.2876C43.6093 38.943 43.6116 38.4083 43.9354 38.0665L50.4213 31.2203C50.7959 30.8249 51.4343 30.8546 51.7705 31.2832L51.8582 31.3949C52.1109 31.717 52.1118 32.1698 51.8605 32.493L51.0221 33.5708C50.866 33.7715 50.803 34.0293 50.8489 34.2794L51.3202 36.8463C51.3549 37.0355 51.4499 37.2084 51.591 37.3392Z",
    fill: "#1E1E1E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4162 41.9928L32.341 41.9928L32.269 42.0149C32.0324 42.0878 31.7395 42.063 31.3828 41.8873C31.0228 41.7101 30.6258 41.3909 30.2216 40.9303C29.4141 40.0099 28.6411 38.5962 28.1201 36.9043C27.8367 35.9843 27.3866 35.0994 26.9834 34.3144C26.9761 34.3001 26.9688 34.2859 26.9615 34.2716C26.5555 33.4813 26.2143 32.8169 26.0613 32.248C25.9105 31.6876 25.9763 31.3557 26.2249 31.1075C26.5259 30.8068 27.1977 30.5129 28.5814 30.3643L28.6292 30.3592L28.6751 30.345C28.9118 30.2721 29.2047 30.2969 29.5614 30.4726C29.9214 30.6499 30.3184 30.969 30.7226 31.4297C31.5301 32.35 32.3031 33.7638 32.8241 35.4556C33.1169 36.4063 33.713 37.3468 34.2745 38.181C34.375 38.3304 34.4739 38.4758 34.5702 38.6173C35.0335 39.2981 35.4366 39.8904 35.6646 40.4092C35.8 40.7172 35.8456 40.9413 35.8333 41.1004C35.8232 41.2316 35.7733 41.3461 35.62 41.4633C35.4462 41.5963 35.1331 41.7345 34.5959 41.8357C34.0648 41.9357 33.3529 41.9928 32.4162 41.9928Z",
    fill: "white",
    stroke: "#1E1E1E"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 28.4731,
    y: 40.9147,
    width: 15.5748,
    height: 5.62992,
    rx: 2.81496,
    fill: "white",
    stroke: "#1E1E1E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5272 29.4512C21.0738 27.9935 21.666 19.8848 21.8938 16.0127H26.3815V27.1735C26.3815 34.0977 31.3925 42.2064 33.898 45.3952C29.5703 45.0915 18.6139 44.3019 18.2495 43.573C17.7939 42.6619 19.8439 31.2734 20.5272 29.4512Z",
    fill: "#1E1E1E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1376 43.5256C11.6799 44.8011 11.3154 47.5496 11.3154 48.7643L23.3873 51.0421L31.3593 58.7863H43.7945V45.6478L17.693 41.5544C16.7819 41.3266 14.5953 42.2501 13.1376 43.5256Z",
    fill: "#1E1E1E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6196 48.8118C57.9603 43.483 58.0516 42.233 58.8846 39.1935C58.996 38.7871 59.3811 38.5143 59.7994 38.5653C67.0713 39.4514 69.47 45.7227 70.6468 48.8118H56.6196Z",
    fill: "#1E1E1E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7652 18.5615C20.1914 16.4881 22.0165 15 24.1332 15H51.5281C53.336 15 54.9651 16.0916 55.6525 17.7638L56.5301 19.8986C56.7714 20.4855 56.3399 21.1296 55.7052 21.1296H20.3312C19.7664 21.1296 19.3438 20.6113 19.4575 20.0581L19.7652 18.5615Z",
    fill: "#1E1E1E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6989 57.6949H8.89187C8.39931 57.6949 7.99774 57.2948 8.02168 56.8028C8.2443 52.2274 10.1292 48.8285 11.2398 47.7539C11.352 47.6454 11.4976 47.5832 11.6522 47.5621C12.3105 47.4724 12.3042 47.5972 20.8907 47.5971C26.5342 47.5971 30.8134 51.3509 32.1432 54.447C32.2975 54.8062 32.6381 55.0632 33.0291 55.0632H54.2077C54.629 55.0632 54.9928 54.7685 55.0802 54.3565L56.3641 48.3039C56.4515 47.8919 56.8122 47.5971 57.2335 47.5971H70.3171C74.6448 47.5971 76.9515 55.8637 74.9143 55.8637C72.9575 55.8637 69.7026 58.4177 66.7415 58.4177C60.7953 58.4177 59.2337 57.6574 58.1266 60.0774C57.9708 60.4179 57.6423 60.6559 57.2679 60.6559H30.2312C29.7673 60.6559 29.3841 60.299 29.3188 59.8397C28.6003 54.7864 25.208 51.0895 19.8441 51.0895C14.7596 51.0895 13.1824 54.7188 12.5858 56.9942C12.4791 57.401 12.1195 57.6949 11.6989 57.6949Z",
    fill: "#1E1E1E"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.7078,
    cy: 59.752,
    rx: 9.39239,
    ry: 9.39239,
    fill: "#1E1E1E"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.7077,
    cy: 59.752,
    r: 5.83851,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 66.8624,
    cy: 59.4974,
    r: 9.13779,
    fill: "#1E1E1E"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 66.8624,
    cy: 59.4975,
    r: 5.68025,
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSportsGolfCartContrast);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/SportsGolfCartContrast.b7574ee42b2263d93bf521f2a895ccc6.svg";